import { render } from "./DispenseOrderItemForOrderTable.html?vue&type=template&id=60a07919&scoped=true"
import script from "./DispenseOrderItemForOrderTable.js?vue&type=script&lang=js"
export * from "./DispenseOrderItemForOrderTable.js?vue&type=script&lang=js"

import "./DispenseOrderItemForOrderTable.css?vue&type=style&index=0&id=60a07919&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a07919"]])

export default __exports__